export enum Source {
    PLUGIN = 'plugin',
    PORTFOLIO = 'portfolio',
    STANDALONE = 'standalone', // For widgets running as standalone apps (except for portfolio)
}

// Version 1 is the legacy version and only used by the AWS Migration, don't use it for new code
// As new versions are created add them to this option list eg Version = 2 | 3 | 4
export type Version = 2;

export * from './UserSession';
export * from './UserAction';
